/** JSON values under PHP float conversion; infinity is retained for the caller
 * to reject at a JSON-output boundary instead of silently converting it to zero. */
export function phpJsonFloat(value: unknown): number {
    if (value == null || value === false) return 0;
    if (value === true) return 1;
    if (typeof value === 'object') return Object.keys(value).length ? 1 : 0;
    if (typeof value === 'number') return value;
    return Number(String(value).match(/^[\t\n\r\v\f ]*[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?/i)?.[0] ?? 0);
}
export const isPhpNumeric = (value: unknown): boolean => typeof value === 'number'
    || (typeof value === 'string' && /^[\t\n\r\v\f ]*[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?[\t\n\r\v\f ]*$/i.test(value));

/** PHP DOUBLE half-away rounding for inventory transforms/costs and derived speeds.
 * Callers pass arithmetic-produced doubles. PHP's integer-argument fast return
 * at nonnegative places is a separate input boundary, not modeled here.
 * Numeric edge comparisons follow PHP 8.5 ext/standard/math.c, independently
 * checked against the installed PHP oracle; this is not Math.round(x * scale).
 * Algorithm reference: https://github.com/php/php-src/blob/PHP-8.5/ext/standard/math.c
 */
export function roundPhpDecimal(value: number, places: 0 | 2 | 4 | 5): number {
    if (!Number.isFinite(value) || value === 0) return value;
    const factor = 10 ** places;
    const direction = value < 0 ? -1 : 1;
    let whole = value < 0 ? Math.ceil(value * factor) : Math.floor(value * factor);
    const adjacent = whole + direction;
    if (adjacent / factor === value) whole = adjacent;
    if (Math.abs(whole) >= 1e16) return value;
    if (Math.abs(value) >= Math.abs((whole + direction * 0.5) / factor)) whole += direction;
    return whole / factor;
}
